import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { isPersonalField } from 'helpers/kpiBuilder/custom';
import { CustomGroup } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { FieldPicker } from './FieldPicker';
import { OptionChips } from './OptionChips';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';

// Group by. The catalogue's groupings are chips; “Another field” groups by any field you name.
export const GroupStep = ({ a, s, patch }: StepProps) => {
  const g = a.custom.group;
  const set = (next: Partial<CustomGroup>) => patch({ custom: { ...a.custom, group: { ...g, ...next } } });

  return (
    <BuilderSection title="Group by" hint="Each group becomes one bar, slice or map area. Pick the place or category you want to compare.">
      <OptionChips options={[...s.groups, { id: 'custom', label: 'Another field…' }]} selected={a.group ? [a.group] : []} onSelect={(id) => patch({ group: String(id) })} />
      {a.group === 'custom' && (
        <div className="border rounded p-3 mt-2 bg-white">
          <FieldPicker fields={fieldsOf(a.src)} value={g.field} placeholder="Field to group by, e.g. channel" onChange={(field) => set({ field })} />
          <div className="mt-2">
            <TextBox value={g.label} placeholder="Name shown on the chart, e.g. Channel" onChange={(label) => set({ label })} />
          </div>
          {isPersonalField(g.field) && <div className="alert alert-warning mt-2 mb-0">Personal data such as phone or email cannot be used to group.</div>}
        </div>
      )}
    </BuilderSection>
  );
};
